import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { ElevionConditionLeaf } from '../elevionConditionLeaf';
import { ElevionConditionLogical } from '../elevionConditionLogical';
export const ElevionCondition = memo(function ElevionNode({ parentName, index, }) {
    const { control,
    // TODO: [TEAMS-13693] remove omit after updating to RHF v8
     } = useFormContext();
    const name = parentName !== undefined && index !== undefined
        ? // TODO fix any
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            `${parentName}.${index}`
        : 'visibility_condition';
    const node = useWatch({
        control,
        name,
    });
    if (!node) {
        return null;
    }
    if (('logicalOp') in node) {
        return _jsx(ElevionConditionLogical, { index: index, parentName: parentName });
    }
    return _jsx(ElevionConditionLeaf, { index: index, parentName: parentName });
});
